// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import {
    Divider,
    IconButton,
    InputAdornment,
    Fab,
    Avatar,
    OutlinedInput
} from '@mui/material'

import Tab from '@mui/material/Tab'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList';
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'; 
import Icon from '../../../components/icon';
import MsiDatagridDynamic from '../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../configs/constant';
import React from 'react';
import { useToast } from '../../../components/ToastProvider';


export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    // ** State
    const [listData, setListData] = useState<any[]>([])
    const { showToast, hideToast } = useToast();

    const [tabs, setTabs] = useState<string>('1')

    const [idGambar, setIdGambar] = useState<any>(null)
    const [file, setFile] = useState<any>(null)
    const [txtFile, setTxtFile] = useState<any>(null)

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    useEffect(() => {
        getData(tabs)
    }, [])

    const navigate = useNavigate();

    const getData = (val: any) => {
        setListData([])
        let url = ''
        if (val == '1') {
            url = apiUrl.apiUrl + '/sales/model/model-aktif'
        } else {
            url = apiUrl.apiUrl + '/sales/model/model-belum-aktif'
        }

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleEdit = (row: any) => {
        navigate('/sales/model/detail/' + row.id)
    };

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/sales/model/delete/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData(tabs)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const customRenderers = {
        link: (value: any, row: any) => (
            <Box
                sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                <Avatar alt="Thumbnail" sx={{ width: 56, height: 56 }} src={value} onClick={() => tampilkanGambar(value)} />
                <IconButton onClick={() => {
                    setOpenDialog(true)
                    setIdGambar(row.id)
                }}>
                    <Icon icon='mdi:pencil' fontSize={20} />
                </IconButton>
            </Box>
        ),
    };

    const tampilkanGambar = (url: string) => {
        if (
            url !== '' &&
            url !== 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        ) {
            Swal.fire({
                imageUrl: url,
                imageAlt: 'Gambar'
            })
        } else {
            showToast('Gambar Tidak Tersedia', 'warning');
        }
    }

    // UPLOAD ATTACHMENT
    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const handleClick = (event: any) => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }

    const handleFile = async (event: any) => {
        const files = event.target.files[0]
        const nameFiles = files.name
        // const image = await resizeFile(files)        
        setFile(files)
        setTxtFile(nameFiles)
        // setValue('file', image)
    }

    const updateGambar = (ids: any) => {
        setOpenDialog(false)
        let url = apiUrl.apiUrl + '/sales/model/upload-image'

        const formData = new FormData();
        formData.append("id", ids);
        formData.append("image", file);

        axios.post(url, formData, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
        }
        }).then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData(tabs)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='MODEL' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => navigate('/sales/model/add')}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    <TabContext value={tabs}>
                        <TabList scrollButtons variant='scrollable' onChange={handleChangeTabs} aria-label='customized tabs example'>
                            <Tab value='1' label='SEMUA MODEL' />
                            <Tab value='2' label='MODEL BELUM AKTIF' />
                        </TabList>
                        <TabPanel value='1'>
                            <MsiDatagridDynamic key={1} data={listData} title='SEMUA MODEL' hiddenColumns={['is_aktif']} onEditRow={handleEdit} onDeleteRow={handleDelete} customRenderers={customRenderers} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <MsiDatagridDynamic key={1} data={listData} title='MODEL BELUM AKTIF' hiddenColumns={['is_aktif', 'id', 'sdmodel_id']}
                                customRenderers={customRenderers} onEditRow={handleEdit} onDeleteRow={handleDelete} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>
            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Upload Gambar
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={12}>
                            <input
                                type='file'
                                ref={hiddenFileInput}
                                onChange={handleFile}
                                style={{ display: 'none' }}
                                accept='image/png, image/jpg, image/jpeg'
                            ></input>
                            <FormControl fullWidth>
                                <InputLabel htmlFor='input-file'>Gambar</InputLabel>
                                <OutlinedInput
                                    label='Foto'
                                    value={txtFile}
                                    id='input-file'
                                    type={'text'}
                                    startAdornment={
                                        <Box
                                            onClick={handleClick}
                                            onMouseDown={e => e.preventDefault()}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <InputAdornment position='start'>
                                                Pilih Gambar &nbsp;
                                                <IconButton edge='start' aria-label='paperclip'>
                                                    <Icon fontSize={20} icon={'mdi:paperclip'} />
                                                </IconButton>
                                            </InputAdornment>
                                        </Box>
                                    }
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} sx={{ textAlign: 'center', my: 2 }}>
                            <Button variant='contained' onClick={() => updateGambar(idGambar)}>
                                SIMPAN
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
